module.exports = "//public.zight.com/packs/media/images/pro-badge-df8e8656ef04c1a96fd28f1b601f03d6.svg";